<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner">
      <!-- <Header></Header> -->
      <!-- <nav-img></nav-img> -->
      <navbar></navbar>
      <div class="main">
        <div class="banner">
          <aside-left class="aside_left"></aside-left>
          <div class="news_main">
            <gengduo-right></gengduo-right>
          </div>
          <advertising class="aside_left_two"></advertising>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
// 引入主导航栏区域
import Header from "../../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../../components/space/Navbar";
// 引入侧边栏区域
import AsideLeft from "../../../components/space/Aside";
import Advertising from "../../../components/space/advertising";
// 引入右侧主体部分
import GengduoRight from "../../../components/space/fensi";
export default {
  data() {
    return {};
  },
  components: {
    top,
    navMenu,
    Header,
    NavImg,
    Navbar,
    AsideLeft,
    GengduoRight,
    Advertising,
  },
  mounted() {
    this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")))
  },
  methods: {
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_fans",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的粉丝列表",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id:  hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  padding-top: 20px;
}
.main {
  background-color: #f5f6f8;
  .banner {
    padding: 25px 0;
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;
    .aside_left {
      float: left;
    }
    .aside_left_two {
      float: left;
      clear: left;
    }
    .news_main {
      float: right;
      width: 877px;
    }
  }
}
</style>